(function () {
  function refineSendvioPopup() {
    var popup = document.getElementById('_chppKRvMe');
    if (!popup || popup.dataset.ffRefined === 'true') return false;
    popup.dataset.ffRefined = 'true';
    popup.classList.add('ff-sendvio-refined');

    var nameInput = popup.querySelector('input[name="name"]');
    if (nameInput && nameInput.closest('.chp_component')) nameInput.closest('.chp_component').hidden = true;

    var emailInput = popup.querySelector('input[name="email"]');
    if (emailInput) {
      emailInput.type = 'email';
      emailInput.id = 'ff-sendvio-email';
      emailInput.setAttribute('autocomplete', 'email');
      emailInput.setAttribute('aria-label', 'Email address');
      emailInput.placeholder = 'Email address';
    }

    var spans = Array.prototype.slice.call(popup.querySelectorAll('.popup_main_wrapper .chp_component > span'));
    if (spans[0]) {
      spans[0].textContent = "Enter Sol'una";
      spans[0].classList.add('ff-sendvio-title');
    }
    if (spans[1]) {
      spans[1].textContent = 'Receive 15% off your first order and first word from across the Meridian.';
      spans[1].classList.add('ff-sendvio-offer');
    }

    var consent = popup.querySelector('.chp_chk_wrpr label');
    var checkbox = popup.querySelector('.chp_chk_policy');
    if (checkbox) checkbox.id = 'ff-sendvio-consent';
    if (consent) {
      consent.htmlFor = 'ff-sendvio-consent';
      consent.textContent = 'Email me new releases, lore, and occasional offers. I can unsubscribe anytime.';
    }

    var submit = popup.querySelector('.popup_main_wrapper .snd_frm');
    if (submit) submit.textContent = 'Send my 15% code';

    var successTitle = popup.querySelector('.popup_success_wrapper .chp_component span');
    if (successTitle) {
      successTitle.textContent = 'Your path is open.';
      successTitle.classList.add('ff-sendvio-title');
    }
    var done = popup.querySelector('.popup_success_wrapper .cls_pp');
    if (done) done.textContent = 'Continue exploring';

    var close = popup.querySelector('.btn_chp_close');
    if (close) close.setAttribute('aria-label', 'Close email offer');
    return true;
  }

  if (!refineSendvioPopup()) {
    var observer = new MutationObserver(function () {
      if (refineSendvioPopup()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }
})();
